var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvancedOauthCompleteInstallation = function SvgAdvancedOauthCompleteInstallation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 156,
    viewBox: "0 0 240 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.48 47.5H61.54v74.67h100.94V47.5Z",
    fill: "#116DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.97 52.86a1.48 1.48 0 1 0 0-2.96 1.48 1.48 0 0 0 0 2.96Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.46 33.83H77.52v74.67h100.94V33.83Z",
    fill: "#C2E2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.46 33.83h-58.82v7.4h58.82v-7.4Z",
    fill: "#28BF9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.37 33.83H77.52v7.4h20.85v-7.4Z",
    fill: "#116DFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.95 39.18a1.48 1.48 0 1 0 0-2.96 1.48 1.48 0 0 0 0 2.96Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.62 39.18a1.48 1.48 0 1 0 0-2.96 1.48 1.48 0 0 0 0 2.96Z",
    fill: "#192C55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.2 50.61H96.78v47.87h62.42V50.61Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.91 62.93a6.226 6.226 0 0 1-.65 2.82 6.43 6.43 0 0 1-5.11 3.58h-1.3a6.43 6.43 0 0 1-5.13-3.58 6.502 6.502 0 0 1-.66-2.82 6.43 6.43 0 0 1 12.85 0Z",
    fill: "#C2E2FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.26 65.75a6.43 6.43 0 0 1-5.11 3.58h-1.3a6.43 6.43 0 0 1-5.13-3.58 5.23 5.23 0 0 1 3.86-1.69h3.81a5.24 5.24 0 0 1 3.87 1.69Z",
    fill: "#28BF9A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.49 64.06a2.69 2.69 0 1 0 0-5.38 2.69 2.69 0 0 0 0 5.38Z",
    fill: "#FFB6AC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.18 61.37a3.01 3.01 0 0 1 0 .52l-2.67-1.78-2.62 1.78a3.01 3.01 0 0 1 0-.52 2.69 2.69 0 1 1 5.38 0h-.09Z",
    fill: "#192C55"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.14 74.69h-21.77v3.18h21.77v-3.18ZM138.14 80.35h-21.77v3.18h21.77v-3.18Z",
    fill: "#C2E2FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.01 88.38H122.2a2.44 2.44 0 0 0-2.44 2.44v.01a2.44 2.44 0 0 0 2.44 2.44h10.81a2.44 2.44 0 0 0 2.44-2.44v-.01a2.44 2.44 0 0 0-2.44-2.44Z",
    fill: "#116DFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m122.33 51.3-13.65-13.65v19.3l4.51-4.51 3.21 7.58 2.76-1.09-3.24-7.63h6.41Z",
    fill: "#192C55"
  })));
};
export default SvgAdvancedOauthCompleteInstallation;